import React from "react";

const VoidedIcon = () => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="STOR-3203"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Icons"
        transform="translate(-64.000000, -688.000000)"
        fill="#317D4F"
      >
        <path
          d="M80,720 C88.836556,720 96,712.836556 96,704 C96,695.163444 88.836556,688 80,688 C71.163444,688 64,695.163444 64,704 C64,712.836556 71.163444,720 80,720 Z M75.4038059,697.989592 L80.0001458,702.586146 L84.5961941,697.989592 C84.7914562,697.79433 85.1080387,697.79433 85.3033009,697.989592 L86.0104076,698.696699 C86.2056698,698.891961 86.2056698,699.208544 86.0104076,699.403806 L81.4141458,704.000146 L86.0104076,708.596194 C86.2056698,708.791456 86.2056698,709.108039 86.0104076,709.303301 L85.3033009,710.010408 C85.1080387,710.20567 84.7914562,710.20567 84.5961941,710.010408 L80.0001458,705.414146 L75.4038059,710.010408 C75.2085438,710.20567 74.8919613,710.20567 74.6966991,710.010408 L73.9895924,709.303301 C73.7943302,709.108039 73.7943302,708.791456 73.9895924,708.596194 L78.5861458,704.000146 L73.9895924,699.403806 C73.7943302,699.208544 73.7943302,698.891961 73.9895924,698.696699 L74.6966991,697.989592 C74.8919613,697.79433 75.2085438,697.79433 75.4038059,697.989592 Z"
          id="status-icon---voided"
        ></path>
      </g>
    </g>
  </svg>
);

export default VoidedIcon;
